export const faqData = [
  {
    question: 'Are the luminous valances reliable?',
    answer: 'Our luminous valances are among the most reliable on the market because they use electroluminescent sheets instead of LED bulbs. They are highly resistant to bad weather and temperature changes. They meet the M1 fire safety standard and come with a 2-year warranty, including parts and labor.'
  },
  {
    question: 'Do the luminous valances consume a lot of energy?',
    answer: 'Smart Awnings luminous valances consume very little energy, as they are designed with electroluminescent sheets powered by 12 volts, which results in energy consumption that is five times lower than a system using LED bulbs.'
  },
  {
    question: 'Who are Smart Awnings products for?',
    answer: 'All our products are intended for everyone — both individuals and professionals. For professionals, Smart Awnings also offers the opportunity to become a reseller partner. Feel free to contact us for more information.'
  },
  {
    question: 'How long does it take to receive my luminous valance?',
    answer: 'You should allow about 15 days from the time your order is confirmed. Our valances are made to order and fully custom-made. This timeframe includes both manufacturing and delivery.'
  },
  {
    question: 'Why choose Smart Awnings?',
    answer: 'Smart Awnings offers highly reliable products at the best prices on the market. As the exclusive partner of the only European supplier of electroluminescent sheets, our products are made in France and come with a 2-year warranty, including parts and labor.'
  }
];